import React from 'react'
import { alpha, Box, BoxProps, styled } from '@mui/material'
import colors from '@src/theme/colors'

const SidebarNav = styled((props: BoxProps) => (
  <Box {...props} component='nav' />
))(
  ({ theme: { spacing, palette, transitions }}) => ({
    display: 'flex',
    flexDirection: 'column',
    padding: spacing(0, 2.5),
    a: {
      borderRadius: 15,
      color: palette.secondary.contrastText,
      display: 'flex',
      fontSize: 17,
      fontWeight: 400,
      marginBottom: 18,
      paddingLeft: 44,
      textDecoration: 'none',
      height: 40,
      alignItems: 'center',
      transition: transitions.create([ 'background' ]),
      '&:hover': {
        // textDecoration: 'underline',
        background: alpha('#fff', 0.25),
      },
      '&.active': {
        background: '#fff',
        color: colors.sidebarActiveItemColor,
      }
    }
  })
)

export default SidebarNav